import { render } from "./RouterLayout.vue?vue&type=template&id=e88ae34c"
import script from "./RouterLayout.vue?vue&type=script&lang=js"
export * from "./RouterLayout.vue?vue&type=script&lang=js"

import "./RouterLayout.vue?vue&type=style&index=0&id=e88ae34c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__